import { Helmet } from 'react-helmet-async';
import { Grid, Container } from '@mui/material';
import { useEffect, useState } from 'react';
import { useNavigate,useLocation} from 'react-router-dom';
import { useParams } from 'react-router';

import { SnackBar } from 'src/components/SnackBar';
import { getRolePermissions } from 'src/services/authService';
import { validateMultiRolesAndPermissions } from 'src/utils/validate';
import TimeEntryView from './components/time-entry-view';
import './TimeEntry.css';

function TimeEntry() {
  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();
  const employeeInfo = location.state;

  const [permissions, setPermissions] = useState([]);

  const getPermissions = (mail) => {
    getRolePermissions(mail).then((res) => {
      const tabs = validateMultiRolesAndPermissions(res);
      const arr = tabs.filter((fil) => fil.name === 'Resource Pool');
      if(arr?.length){
        setPermissions(arr[0].permissions);
      }
    });
  };

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user') || '{}');

    if (Object.keys(user).length === 0) {
      navigate('/');
    } else {
      getPermissions(user.Email);
    }
  }, [navigate]);

  return (
    <>
      <Helmet>
        <title>Timesheet</title>
      </Helmet>
      <Container maxWidth="xl">
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="stretch"
          spacing={3}
        >
          <Grid item xs={12}>
            <TimeEntryView tab={params.type} permissions={permissions} id={params.id}  employeeInfo={employeeInfo} />
          </Grid>
        </Grid>
        <SnackBar />
      </Container>
    </>
  );
}

export default TimeEntry;
